jQuery(window).scroll(function() {    
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 50) {
        jQuery("header").addClass("headerFix");
	} else if (scroll >= 50) {
        jQuery("header").addClass("headerFix2");
    } else {
        jQuery("header").removeClass("headerFix");
		jQuery("header").removeClass("headerFix2");
		
    }
});

jQuery("header .menu-toggle button").click(function(){
  jQuery(this).toggleClass("open");
    jQuery("header .headerNav").toggleClass("open");
});

jQuery("header .headerNav ul li.mega-menu").click(function(e){
     if (e.target !== this) return;
  //jQuery(this).toggleClass("open");
   // jQuery("header .headerNav ul li .sub-menu-lavel-1").toggleClass("open");
    jQuery("header .headerNav ul li.mega-menu span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li .sub-menu-lavel-1").toggleClass("open");    
});
jQuery("header .headerNav ul li.mega-menu a.main-link").click(function(e){
     if (e.target !== this) return;
  //jQuery(this).toggleClass("open");
   // jQuery("header .headerNav ul li .sub-menu-lavel-1").toggleClass("open");
    jQuery("header .headerNav ul li.mega-menu span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li .sub-menu-lavel-1").toggleClass("open");    
});
jQuery("header .headerNav ul li.mega-menu span.menu-arrow").click(function(e){
 //    if (e.target !== this) return;
  jQuery(this).toggleClass("open");
    jQuery("header .headerNav ul li .sub-menu-lavel-1").toggleClass("open");
      
});

jQuery("header .headerNav ul li .sub-menu-lavel-1 li#lavel1-1").click(function(){
    jQuery('header .headerNav ul li .sub-menu-lavel-1 li#lavel1-1 i').toggleClass("open");
    jQuery("header .headerNav ul li.sub-menu#lavel1-1 .sub-menu-lavel-2").toggleClass("open");
});

jQuery("header .headerNav ul li .sub-menu-lavel-1 li#lavel1-2").click(function(){
  //  jQuery(this).toggleClass("open");
 //   jQuery("header .headerNav ul li.sub-menu#lavel1-2 .sub-menu-lavel-2").toggleClass("open");
    jQuery('header .headerNav ul li .sub-menu-lavel-1 li#lavel1-2 i').toggleClass("open");
    jQuery("header .headerNav ul li.sub-menu#lavel1-2 .sub-menu-lavel-2").toggleClass("open");
});

jQuery("header .headerNav ul li .sub-menu-lavel-1 li#lavel1-3").click(function(){
 //   jQuery(this).toggleClass("open");
  //  jQuery("header .headerNav ul li.sub-menu#lavel1-3 .sub-menu-lavel-2").toggleClass("open");

    jQuery('header .headerNav ul li .sub-menu-lavel-1 li#lavel1-3 i').toggleClass("open");
    jQuery("header .headerNav ul li.sub-menu#lavel1-3 .sub-menu-lavel-2").toggleClass("open");
});

jQuery("header .headerNav ul li .sub-menu-lavel-1 li#lavel1-4").click(function(){
   // jQuery(this).toggleClass("open");
   // jQuery("header .headerNav ul li.sub-menu#lavel1-4 .sub-menu-lavel-2").toggleClass("open");
     jQuery('header .headerNav ul li .sub-menu-lavel-1 li#lavel1-4 i').toggleClass("open");
    jQuery("header .headerNav ul li.sub-menu#lavel1-4 .sub-menu-lavel-2").toggleClass("open");
});
/*
jQuery("header .headerNav ul #single-dm1").click(function(){
    jQuery("header .headerNav ul #single-dm1 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul #single-dm1").toggleClass("open");    
});
*/
jQuery("header .headerNav ul li.single-menu#single-dm2").click(function(){
    jQuery("header .headerNav ul li.single-menu#single-dm2 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm2").toggleClass("open");    
});
jQuery("header .headerNav ul li.single-menu#single-dm3").click(function(){
    jQuery("header .headerNav ul li.single-menu#single-dm3 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm3").toggleClass("open");
});
jQuery("header .headerNav ul li.single-menu#single-dm4").click(function(){
    jQuery("header .headerNav ul li.single-menu#single-dm4 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm4").toggleClass("open");
});
jQuery("header .headerNav ul li.single-menu#single-dm5").click(function(){
   jQuery("header .headerNav ul li.single-menu#single-dm5 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm5").toggleClass("open");
});
jQuery("header .headerNav ul li.single-menu#single-dm6").click(function(){
    jjQuery("header .headerNav ul li.single-menu#single-dm6 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm6").toggleClass("open");
});
jQuery("header .headerNav ul li.single-menu#single-dm7").click(function(){
    jQuery("header .headerNav ul li.single-menu#single-dm7 span.menu-arrow").toggleClass("open");
    jQuery("header .headerNav ul li.single-menu#single-dm7").toggleClass("open");
});

jQuery(document).ready(function() {
  var scrollAmount = 400;

  jQuery('.scroll-btn.left').on('click', function() {
    jQuery('.mainrow-outer').animate({ scrollLeft: '-=' + scrollAmount }, 400);
  });

  jQuery('.scroll-btn.right').on('click', function() {
    jQuery('.mainrow-outer').animate({ scrollLeft: '+=' + scrollAmount }, 400);
  });
});


